import { apiClient } from '@/shared/api';
import type {
  CoachingTreeResponse,
  CompetencyCreateRequest,
  CompetencyForRuleResponse,
  CompetencyResponse,
  CompetencyUpdateRequest,
  LinkRulesRequest,
  LinkRulesResponse,
  ReorderRequest,
} from './types';

// GET /coaching/competency - получить дерево компетенций
export const fetchCompetencyTree = async () => {
  const { data } = await apiClient.get<CoachingTreeResponse>('/coaching/competency');
  return data;
};

// POST /coaching/competency - создать компетенцию
export const createCompetency = async (body: CompetencyCreateRequest) => {
  const { data } = await apiClient.post<CompetencyResponse>('/coaching/competency', body);
  return data;
};

// PUT /coaching/competency/{id} - обновить компетенцию
export const updateCompetency = async (params: { id: number; body: CompetencyUpdateRequest }) => {
  const { data } = await apiClient.put<CompetencyResponse>(`/coaching/competency/${params.id}`, params.body);
  return data;
};

// DELETE /coaching/competency/{id} - удалить компетенцию (soft delete)
export const deleteCompetency = async (id: number) => {
  const { data } = await apiClient.delete(`/coaching/competency/${id}`);
  return data;
};

// PUT /coaching/competency/{id}/rules - привязка правил к компетенции
export const linkRules = async (params: { id: number; body: LinkRulesRequest }) => {
  const { data } = await apiClient.put<LinkRulesResponse>(`/coaching/competency/${params.id}/rules`, params.body);
  return data;
};

// PUT /coaching/competency/reorder - перестановка компетенций (drag-drop)
export const reorderCompetencies = async (body: ReorderRequest) => {
  const { data } = await apiClient.put('/coaching/competency/reorder', body);
  return data;
};

// GET /coaching/competency/by-rule/{ruleId} - компетенции для правила
export const fetchCompetenciesForRule = async (ruleId: number) => {
  const { data } = await apiClient.get<CompetencyForRuleResponse>(`/coaching/competency/by-rule/${ruleId}`);
  return data;
};
